<template>
  <md-list class="md-dense">
    <transition-group tag="li">
      <md-list-item class="item" v-for="item in items" :key="item.code">
        <md-checkbox
          v-if="selectable"
          :model="selected"
          @change="$emit('update:selected', $event)"
          :value="item"
        />
        <span class="md-list-item-text item-code">{{ item.code }}</span>
        <span class="md-list-item-text item-name">{{ item.name }}</span>
        <span class="md-list-item-text item-ymd">{{ item.ymd | ymd }}</span>
        <span v-if="deletable" class="icon-delete" @click="remove(item)">
          <md-icon>remove_circle_outline</md-icon>
        </span>
      </md-list-item>
    </transition-group>
  </md-list>
</template>

<script>
import { formatDate } from '@/util/date'

/**
 * 商品の一覧表示
 */
export default {
  filters: {
    ymd: formatDate,
  },
  props: {
    /**
     * 表示する商品リスト
     *
     * 商品は以下の形式
     *
     * ```javascript
     * {
     *   code: String,
     *   name: String,
     *   category: String,
     * }
     * ```
     */
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * 選択されている商品
     */
    selected: {
      type: Array,
      default: () => [],
    },
    /**
     * 選択可能か
     */
    selectable: {
      type: Boolean,
      default: false,
    },
    /**
     * 削除可能か
     */
    deletable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * 要素の削除
     */
    remove(item) {
      this.$emit('update:items', this.items.filter(i => i.code !== item.code))
    },
  },
}
</script>

<style lang="scss" scoped>
.item {
  width: 100%;

  &:hover {
    background: rgba(0, 0, 0, 0.12);
  }
}

.md-list-item-text {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 商品コード、分類のテキストの横幅を固定にし、商品名称を横幅いっぱいにする
.item-code {
  flex: 0 0 150px;
}
.item-name {
  flex: 1;
}
.item-ymd {
  flex: 0 0 120px;
}

.icon-delete {
  cursor: pointer;
}

// 商品一覧の追加/削除時のアニメーション
.item {
  transition: all 0.2s ease-in-out;
}
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(50px);
}
.v-leave-active {
  position: absolute;
}
</style>
